<template>
  <v-divider class="grey lighten-3" />
</template>

<script>
  export default {
    name: 'DataDivider'
  }
</script>
